export const isDesktop = () => {
  return global.device.desktop()
}
export const isIos = () => {
  return global.device.ios()
}
export const isAndroid = () => {
  return global.device.android()
}
